import "@/views/auth/email-change/emailChangeFragment";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./instrument";
import { App } from "./App";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { AuthProvider } from "@/providers/auth-provider";
import { CSAnalyticsProvider } from "@/providers/analytics";
import { AppBrowserRouter } from "@/providers/app-router";
import { ErrorBoundary } from "./providers/error-boundary";
import { ToastContainer } from "react-toastify";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LocaleProvider } from "@/contexts/LocaleContext";
import { VersionPollingWrapper } from "@/components/app/VersionPollingWrapper";

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <TooltipProvider delayDuration={167}>
      <Provider store={store}>
        <AppBrowserRouter>
          <CSAnalyticsProvider>
            <AuthProvider>
              <LocaleProvider>
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />

                <VersionPollingWrapper>
                  <App />
                </VersionPollingWrapper>
              </LocaleProvider>
            </AuthProvider>
          </CSAnalyticsProvider>
        </AppBrowserRouter>
      </Provider>
    </TooltipProvider>
  </ErrorBoundary>,
);
